// import * as bi from 'public/bi';

$w.onReady(function () {
	/*
	bi.code.log(129, {
		'page_url': encodeURIComponent(wixLocation.url)
	});
	*/
});